import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
// import { useTranslation } from "react-i18next";
import FormContainer from "components/form-container";

export default function DropoffSellerAlreadyCompleted() {
  // const { t } = useTranslation();
  const { setSidebarVisual } = useOutletContext();

  // Set sidebar visual
  useEffect(() => {
    setSidebarVisual("man");
  }, [setSidebarVisual]);

  return (
    <FormContainer submitLabel="My Trade-Ins" submitHref="/en-US/my-trade-ins">
      <div className="flex flex-col items-center text-center gap-x-large">
        {/* Check mark icon */}
        <div className="w-24 h-24 md:w-32 md:h-32 bg-green-100 rounded-full flex items-center justify-center">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-green-600 rounded-full flex items-center justify-center">
            <svg
              className="w-8 h-8 md:w-10 md:h-10 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M5 13l4 4L19 7"
              ></path>
            </svg>
          </div>
        </div>

        {/* Message */}
        <div className="flex flex-col gap-regular">
          <h1 className="text-primary text-4xl md:text-6xl font-semibold">
            This trade-in has already been completed
          </h1>

          <p className="text-tertiary text-lg md:text-xl">
            An email containing your LEGO® e-Gift Card has been sent.
          </p>
        </div>
      </div>
    </FormContainer>
  );
}
